var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-carousel',{staticClass:"mb-4"}),_c('swiper-example-slides-per-column',{staticClass:"mb-3"}),_c('home-ca',{staticClass:"mb-2"}),_c('home-ca-guzhu'),_c('home-ie'),_c('home-usa'),_c('home-others')],1)}
var staticRenderFns = []

export { render, staticRenderFns }